// extracted by mini-css-extract-plugin
module.exports = {"light-mode":"PageNotFound_light-mode__3ZNCA","errorPage":"PageNotFound_errorPage__1p7ys"};